import { createContext, useContext, useState } from "react";

import type { PanelFlowContextValue, PanelFlowProviderProps } from "./types";

const PanelFlowContext = createContext<PanelFlowContextValue>({
  panels: [],
  state: "",
  setState: () => undefined,
  panelKey: "",
  setPanelKey: () => undefined,
});

export const PanelFlowProvider: React.FC<PanelFlowProviderProps> = ({
  panels,
  defaultPanelKey,
  state,
  setState,
  extraProps,
  children,
}) => {
  const [panelKey, setPanelKey] = useState(defaultPanelKey);

  return (
    <PanelFlowContext.Provider
      value={{ panels, panelKey, setPanelKey, state, setState, extraProps }}
    >
      {children}
    </PanelFlowContext.Provider>
  );
};

export const usePanelFlowContext = () => useContext<PanelFlowContextValue>(PanelFlowContext);
